import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LogOut, Users, Trophy, Settings, GraduationCap, UserCog } from "lucide-react";
import { SITE } from "@/lib/site";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AdminNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const onLogout = () => {
    logout();
    toast.success("Signed out");
    navigate("/admin/login", { replace: true });
  };

  const tabs = [
    { to: "/admin/leads", label: "Leads", icon: Users, testid: "admin-tab-leads" },
    { to: "/admin/toppers", label: "Toppers", icon: Trophy, testid: "admin-tab-toppers" },
    { to: "/admin/faculty", label: "Faculty", icon: GraduationCap, testid: "admin-tab-faculty" },
    { to: "/admin/students", label: "Students", icon: UserCog, testid: "admin-tab-students" },
    { to: "/admin/content", label: "Content", icon: Settings, testid: "admin-tab-content" },
  ];

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between gap-4">
        <a href="/" className="flex items-center gap-3" data-testid="admin-logo-link">
          <img src={SITE.logo.horizontal} alt={SITE.name} className="h-9 md:h-10 w-auto object-contain" />
        </a>

        <nav className="flex items-center gap-1 bg-slate-100 rounded-full p-1">
          {tabs.map(({ to, label, icon: Icon, testid }) => {
            const active = pathname.startsWith(to);
            return (
              <Link
                key={to}
                to={to}
                data-testid={testid}
                className={`inline-flex items-center gap-2 px-4 md:px-5 py-2 rounded-full text-sm font-inter font-medium transition-all ${
                  active ? "bg-[#002570] text-white shadow-md" : "text-slate-600 hover:text-[#002570]"
                }`}
              >
                <Icon className="w-4 h-4" />
                <span className="hidden sm:inline">{label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden md:inline-flex font-inter text-sm text-slate-600">{user?.email}</span>
          <button
            onClick={onLogout}
            data-testid="admin-logout-btn"
            className="inline-flex items-center gap-2 bg-[#002570] text-white hover:bg-[#001a52] rounded-full px-4 md:px-5 py-2.5 text-sm font-inter font-medium transition-colors"
          >
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
